module.exports = __webpack_public_path__ + "static/media/ribbonNewYear.f43b98fb.png";